import { createStore } from "vuex";

import actions from './actions'
import state from './state'
import mutations from './mutations'
import getters from './getters'

import courseX from './modules/courseX' // دوره ها
import controlPanelX from './modules/controlPanelX' // کنترل پنل


const store = createStore({
  state,
  getters,
  mutations,
  actions,
  modules: {
    courseX,
    controlPanelX
  },

});
export default store;


